import styled from "styled-components";
import theme from "./../../styles/theme"

export const RecognitionSection = styled.section`
  padding: 40px 20px;

  img{
    width: 30%!important;
    -webkit-transition: .3s ease;
    -moz-transition: .3s ease;
    -o-transition: .3s ease;
    transition: .3s ease;
    padding-top: 30px;
  }

  @media (max-width:  ${theme.breakpoints.medium}) {
    img{
      width: 100%!important;
      padding: 0;
    }
  }
  .slick-slider{
    .slick-prev{
      top: 72%;
      @media (max-width:  ${theme.breakpoints.medium}){
        left: -10px;
        top: 100px;
        z-index: 1;

        &:before{
          content: none;
        }
      }
      @media (max-width: 390px){
        top: 90px;
      }
    }
    .slick-next{
      top: 72%;
      @media (max-width:  ${theme.breakpoints.medium}){
        right: 15px;
        top: 100px;
        z-index: 9;
        &:before{
          content: none;
        }
      }
      @media (max-width: 390px){
        top: 90px;
      }
    }


  }

  .ArrowRecogbition{
    padding: 10px;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transition:  .3s ease;
    -moz-transition:  .3s ease;
    -o-transition:  .3s ease;
    transition:  .3s ease;

    &:hover{
      background:  ${theme.colors.landingTheme};

      path{
        fill: ${theme.colors.white}!important;
      }

      @media (max-width:  ${theme.breakpoints.medium}){
        background-color: ${theme.colors.white};

        path{
          fill: ${theme.colors.gray}!important;
        }
      }
    }
  }

  .slick-slide{
    .boxsize{
      display: none;
      img{
        width: 10px!important;
      }
      @media (max-width:  ${theme.breakpoints.medium}){
        display: flex;
      }
    }
  }
  .slick-slide.slick-active.slick-center.slick-current{
    .boxsize{
      display: flex;
        img{
        width: 10px!important;
      }
    }
    img{
      width: 60%!important;
      padding: 0;
    }

    @media (max-width:  ${theme.breakpoints.medium}) {
      img{
        width: 100%!important;
      }
    }
  }
`;

export const RecognitionTitle = styled.h4`
  color: ${theme.colors.gray};
  font-family: ${theme.fonts.montSerrat};
  font-size: ${theme.fontSizes.xxLarge};
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  line-height: 44px;
  padding-bottom: 50px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    font-size: 28px;
  }
`;
